<template>
  <div class="modules">
    <div class="module d-flex align-items-center" v-for="(mod, index) in displayModules" :key="index">
      <a :href="mod.href" class="img-wrap custom_click_track" target="_blank" :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'INCENT', mod.tracking_id)">
        <img :src="`${store.baseUrl}/images/redeem_points/placeholder.png`" :data-src="mod.img_src" class="lazy" :alt="mod.img_alt">
      </a>
      <div class="copy">
        <a :href="mod.href" class="heading-link custom_click_track" target="_blank" :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'INCENT', mod.tracking_id)">
          <h4 class="subheading-2 mb-2" v-html="mod.heading"></h4>
        </a>
        <p v-html="mod.body"></p>
        <a :href="mod.href" class="link-arrow mt-2 custom_click_track" target="_blank" :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'INCENT', mod.tracking_id)">{{ mod.cta_copy }}</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { randomArrIndex, trackingAttr } from '../utilities';
import { useStore } from '../store';

const store = useStore();
const data = content.redeem_points;

const displayModules = computed(() => {
  let modules = [];
  modules.push(data.low[randomArrIndex(data.low)]);
  modules.push(data.med[randomArrIndex(data.med)]);
  modules.push(data.high[randomArrIndex(data.high)]);
  return modules;
});
</script>
